import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ApiSuccess,
  LineSettingInput,
  LineSettingTestResult,
  LineSettingView,
} from '@app/shared';
import { apiClient } from '../../lib/api-client';

const KEY = ['settings', 'line'];

export function useLineSetting() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<LineSettingView> => {
      const res = await apiClient.get<ApiSuccess<LineSettingView>>('/settings/line');
      return res.data.data;
    },
  });
}

export function useUpdateLine() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: LineSettingInput): Promise<LineSettingView> => {
      const res = await apiClient.put<ApiSuccess<LineSettingView>>('/settings/line', input);
      return res.data.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useTestLine() {
  return useMutation({
    mutationFn: async (): Promise<LineSettingTestResult> => {
      const res = await apiClient.post<ApiSuccess<LineSettingTestResult>>(
        '/settings/line/test',
      );
      return res.data.data;
    },
  });
}
